import styled from 'styled-components'

import { boxModelTypes, cssTypes, positionTypes } from '../types'
import { boxModel, css, position } from '../util'

/**
 * @namespace Position
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Position = styled.div`
  ${boxModel};
  ${css};
  ${position};
`

/**
 * @name defaultProps
 * @memberof Position
 * @desc Primitive's default properties
 */
Position.defaultProps = {
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Position
 * @desc Primitive's prop type definitions
 */
Position.propTypes = {
  ...boxModelTypes,
  ...cssTypes,
  ...positionTypes,
}

/** @component */
export default Position
